// extracted by mini-css-extract-plugin
module.exports = {"box":"rowBox_box__A2Mwu","pageBtn":"rowBox_pageBtn__FDkI2","pageBtnActive":"rowBox_pageBtnActive__0Qr7L"};